var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 1 }
            },
            [
              _c("el-step", { attrs: { title: "海运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "增值服务" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "托运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: _vm.$t("i18n_confirm_order") } }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_order_completed") }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "center_wrap" }, [
      _c(
        "div",
        { staticClass: "wrap_l" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.formData, function(item, index) {
            return _c("div", { key: index, staticClass: "Item_list" }, [
              _c(
                "div",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: item.checked,
                        callback: function($$v) {
                          _vm.$set(item, "checked", $$v)
                        },
                        expression: "item.checked"
                      }
                    },
                    [_vm._v(_vm._s(item.feeName))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.checked,
                      expression: "item.checked"
                    }
                  ],
                  staticClass: "LR_center",
                  staticStyle: { width: "100%", float: "left" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "count_center",
                      staticStyle: {
                        padding: "25px 25px 0 25px",
                        "box-sizing": "border-box"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.feeCode != "COD",
                              expression: "item.feeCode != 'COD'"
                            }
                          ]
                        },
                        [
                          item.feeCode != "CLEF"
                            ? _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v("￥" + _vm._s(item.cnyprice))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.feeCode == "CLEF"
                            ? _c(
                                "div",
                                { staticStyle: { "padding-top": "5px" } },
                                [
                                  _c(
                                    "div",
                                    {},
                                    [
                                      _c("test", {}, [
                                        _vm._v(
                                          "基础操作：" +
                                            _vm._s(item.currency) +
                                            _vm._s(item.basePrice)
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {},
                                    [
                                      _c("test", {}, [
                                        _vm._v(
                                          "报关单份：" +
                                            _vm._s(item.currency) +
                                            _vm._s(item.declarePrice)
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.feeCode == "COD",
                              expression: "item.feeCode == 'COD'"
                            }
                          ],
                          staticStyle: { float: "left" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              size: "mini",
                              type: "number",
                              placeholder: "请输入金额"
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeinput(item)
                              }
                            },
                            model: {
                              value: item.price,
                              callback: function($$v) {
                                _vm.$set(item, "price", $$v)
                              },
                              expression: "item.price"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.feeCode == "COD",
                              expression: "item.feeCode == 'COD'"
                            }
                          ],
                          staticClass: "centerstyle",
                          staticStyle: {
                            float: "left",
                            width: "100px",
                            "margin-left": "5px",
                            margin: "0 15px"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { size: "mini", placeholder: "请选择" },
                              on: {
                                change: function($event) {
                                  return _vm.changemoney(_vm.showMoneythst.rate)
                                }
                              },
                              model: {
                                value: _vm.showMoneythst.rate,
                                callback: function($$v) {
                                  _vm.$set(_vm.showMoneythst, "rate", $$v)
                                },
                                expression: "showMoneythst.rate"
                              }
                            },
                            _vm._l(_vm.moneytype, function(_item) {
                              return _c(
                                "el-option",
                                {
                                  key: _item.rate,
                                  attrs: {
                                    label: _item.currencyTo,
                                    value: _item.rate
                                  }
                                },
                                [_vm._v(_vm._s(_item.currencyTo))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.feeCode != "COD",
                              expression: "item.feeCode != 'COD'"
                            }
                          ],
                          staticStyle: { float: "left", "margin-left": "15px" }
                        },
                        [
                          _c("el-input-number", {
                            attrs: { size: "mini", min: 1, max: 999 },
                            on: {
                              change: function($event) {
                                return _vm.handleChange1(item)
                              }
                            },
                            model: {
                              value: item.piece,
                              callback: function($$v) {
                                _vm.$set(item, "piece", $$v)
                              },
                              expression: "item.piece"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.feeUnit) +
                            "\n            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "25px 0px 0 25px",
                        "box-sizing": "border-box"
                      }
                    },
                    [
                      _vm._v(
                        "\n            预估费用：￥" +
                          _vm._s(item.cnyamount) +
                          "\n          "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              (item.feeCode == "CLEF") & item.checked
                ? _c(
                    "div",
                    { staticStyle: { float: "right", color: "#ccc" } },
                    [
                      _vm._v(
                        "\n              *续页会产生额外续页费" +
                          _vm._s(item.currency) +
                          _vm._s(item.remark) +
                          "/" +
                          _vm._s(item.feeUnit) +
                          "\n          "
                      )
                    ]
                  )
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formData.length == 0,
                  expression: "formData.length == 0"
                }
              ],
              staticStyle: { padding: "20px" }
            },
            [
              _c("el-alert", {
                attrs: {
                  closable: false,
                  title: "该线路暂无增值服务",
                  type: "warning",
                  description: "该线路暂无增值服务，请点击下一步继续操作",
                  "show-icon": ""
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "16px",
                "font-family": "PingFang SC",
                "font-weight": "500",
                color: "#343434"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("i18n_cost_calculation")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "OrderDetails" }, [
            _c(
              "div",
              {
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [_vm._v("海运费")]),
                _vm._v(" "),
                _vm._l(_vm.HYFmoney.goodsTypeFeeDTOS, function(item, index) {
                  return _c("p", { key: index, staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(item.goodsTypeName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("(" + _vm._s(item.calDesc) + ")")
                    ])
                  ])
                }),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.HYFmoney.currency) +
                        _vm._s(_vm.HYFmoney.amount)
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tuoCheData.checked,
                    expression: "tuoCheData.checked"
                  }
                ],
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [
                  _vm._v("提货费"),
                  _vm.tuoCheData.minKilometer
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "13px",
                            float: "right",
                            "font-weight": "500"
                          }
                        },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.tuoCheData.minKilometer + "KM") +
                              "--" +
                              _vm._s(_vm.tuoCheData.maxKilometer + "KM") +
                              ")"
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v("发货地上门提货")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.tuoCheData.currency) +
                        _vm._s(_vm.tuoCheData.amount)
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.PSFmoney.checked,
                    expression: "PSFmoney.checked"
                  }
                ],
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [_vm._v("配送费")]),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v("目的地送货上门")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.PSFmoney.currency) +
                        _vm._s(_vm.PSFmoney.amount)
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "Item_Right" },
              [
                _c("p", { staticClass: "tit" }, [_vm._v("增值服务费")]),
                _vm._v(" "),
                _vm._l(_vm.formData, function(item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.checked,
                          expression: "item.checked"
                        }
                      ],
                      key: index,
                      staticClass:
                        "coutText animate__animated animate__bounceInRight"
                    },
                    [
                      _c("span", { staticClass: "littit" }, [
                        _vm._v(_vm._s(item.feeName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fontString" }, [
                        _vm._v(
                          _vm._s(item.currency) +
                            _vm._s(item.amount) +
                            "\n              "
                        ),
                        item.feeCode == "CLEF"
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(item.basePrice) +
                                  "+" +
                                  _vm._s(item.cnycontinuationPrice) +
                                  "*" +
                                  _vm._s(item.piece)
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(item.piece) +
                                  "*" +
                                  _vm._s(item.price)
                              )
                            ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.feeUnit,
                                expression: "item.feeUnit"
                              }
                            ],
                            staticClass: "fontString"
                          },
                          [_vm._v(_vm._s(item.feeUnit))]
                        ),
                        _vm._v(")")
                      ])
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "Item_Right" }, [
              _c(
                "p",
                { staticClass: "coutText" },
                [
                  _c("span", { staticClass: "littit" }, [_vm._v("合计费用")]),
                  _vm._v(" "),
                  _vm._l(this.newArray, function(item, index) {
                    return _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.amount > 0,
                            expression: "item.amount > 0"
                          }
                        ],
                        key: index
                      },
                      [
                        _c("span", [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.currency != "",
                                  expression: "item.currency != ''"
                                }
                              ],
                              staticClass: "fontString"
                            },
                            [_vm._v(_vm._s(item.currency))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.amount > 0,
                                  expression: "item.amount > 0"
                                }
                              ],
                              staticClass: "fontString",
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-right": "5px"
                              }
                            },
                            [_vm._v(_vm._s(item.amount))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  index == _vm.newArray.length - 1
                                    ? false
                                    : true,
                                expression:
                                  "index == newArray.length - 1 ? false : true"
                              }
                            ]
                          },
                          [_vm._v("+")]
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", { staticClass: "coutText" }, [
                _c("span", { staticClass: "littit" }, [_vm._v("折合人民币")]),
                _vm._v(" "),
                _c("span", { staticClass: "fontString" }, [
                  _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                "margin-top": "30px",
                float: "left"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      on: {
                        click: function($event) {
                          return _vm.pathToback()
                        }
                      }
                    },
                    [_vm._v("上一步")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "100%", "margin-top": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        background: "#604aff",
                        color: "#ffffff"
                      },
                      on: {
                        click: function($event) {
                          return _vm.pathToNext()
                        }
                      }
                    },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "-webkit-flex", "align-items": "center" } },
      [
        _c("img", {
          attrs: { src: require("../../assets/style.png"), alt: "" }
        }),
        _vm._v(" "),
        _c(
          "p",
          {
            staticStyle: {
              "font-size": "20px",
              "font-family": "PingFang SC",
              "font-weight": "500",
              color: "#333333",
              "margin-left": "10px"
            }
          },
          [_vm._v("\n          增值服务\n        ")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4d5a986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4d5a986","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/newservice.vue
// module id = null
// module chunks = 